import {
    faBabyCarriage,
    faMapMarkerAlt,
    faPuzzlePiece,
    faShoePrints,
} from "@fortawesome/pro-solid-svg-icons";
import cx from "classnames";
import React from "react";

import { bazaarUrl } from "@/mk2/apps/bazaar/urls";
import BazaarSearch from "@/mk2/apps/home/components/BazaarSearch";
import { BluePill } from "@/mk2/apps/home/components/BluePill";
import { HomePageState } from "@/mk2/apps/home/containers/Home/Home.reducers";
import { Interpolate } from "@/mk2/components/Interpolate";
import { LoadingPlaceholder } from "@/mk2/components/LoadingPlaceholder";
import { url } from "@/mk2/helpers/urls";
import { UserEntity } from "@/mk2/schemas";
import { RouteNavigateFunction } from "@/mk2/services/browserHistory";
import {
    index as categoriesIndex,
    prams_and_accessories as pramsAndAccessoriesCategory,
} from "@/mk/autogenerated/bzCategories";
import {
    BZ2_CAT_FOOTWEAR,
    BZ2_CAT_PRAMS,
    BZ2_CAT_TOYS,
    HOME_SHOW_PRODUCTS_FROM_location,
} from "@/mk/autogenerated/translation";
import { getCountyName } from "@/mk/geo";
import { bazaar_single_page_product_grid_category_url } from "@/mk/urls/functions";

import styles from "./Bazaar2.mscss";

const pramsCategory = pramsAndAccessoriesCategory.find((c) => c.name === "prams");
const footwearCategory = categoriesIndex.find((c) => c.name === "footwear");
const toysCategory = categoriesIndex.find((c) => c.name === "toys");

interface OwnProps {
    className?: string;

    prams: number;
    footwear: number;
    toys: number;
    others: number;
    routeNavigate: RouteNavigateFunction;
    isMobile: boolean;
    places: Record<number, number>;
    place: HomePageState["place"];
    requestUser: UserEntity;
}

type Props = OwnProps;

class Bazaar2 extends React.PureComponent<Props> {
    public render() {
        const { className, place, places, routeNavigate } = this.props;

        return (
            <div className={cx(styles.Bazaar2, className)}>
                <BazaarSearch routeNavigate={routeNavigate} />

                <div className={styles.Bazaar2__categories}>
                    <BluePill
                        className={styles.Bazaar2__category}
                        to={bazaar_single_page_product_grid_category_url(pramsCategory.slug)}
                        label={BZ2_CAT_PRAMS}
                        icon={faBabyCarriage}
                    />
                    <BluePill
                        className={styles.Bazaar2__category}
                        to={bazaar_single_page_product_grid_category_url(footwearCategory.slug)}
                        label={BZ2_CAT_FOOTWEAR}
                        icon={faShoePrints}
                    />
                    <BluePill
                        className={styles.Bazaar2__category}
                        to={bazaar_single_page_product_grid_category_url(toysCategory.slug)}
                        label={BZ2_CAT_TOYS}
                        icon={faPuzzlePiece}
                    />
                    {place?.countyId &&
                        places[place?.id] && ( // Places without countyId cannot be set in facets
                            <BluePill
                                className={styles.Bazaar2__category}
                                to={url(
                                    bazaarUrl,
                                    {},
                                    {
                                        places: place.id,
                                        locations: getCountyName(place.countyId),
                                    },
                                )}
                                icon={faMapMarkerAlt}
                                label={
                                    <Interpolate
                                        i18nKey={HOME_SHOW_PRODUCTS_FROM_location}
                                        location={<strong>{place.name}</strong>}
                                    />
                                }
                            />
                        )}
                </div>
            </div>
        );
    }
}

export default Bazaar2;

interface PlaceholderOwnProps {
    className?: string;
    routeNavigate: RouteNavigateFunction;
    isMobile: boolean;
}

let Bazaar2Placeholder: React.FunctionComponent<PlaceholderOwnProps> = ({
    className,
    routeNavigate,
}) => (
    <div className={cx(styles.Bazaar2, className)}>
        <BazaarSearch routeNavigate={routeNavigate} />

        <div className={styles.Bazaar2__categories}>
            <BluePill
                className={styles.Bazaar2__category}
                to={bazaar_single_page_product_grid_category_url(pramsCategory.slug)}
                label={BZ2_CAT_PRAMS}
                icon={faBabyCarriage}
            />
            <BluePill
                className={styles.Bazaar2__category}
                to={bazaar_single_page_product_grid_category_url(footwearCategory.slug)}
                label={BZ2_CAT_FOOTWEAR}
                icon={faShoePrints}
            />
            <BluePill
                className={styles.Bazaar2__category}
                to={bazaar_single_page_product_grid_category_url(toysCategory.slug)}
                label={BZ2_CAT_TOYS}
                icon={faPuzzlePiece}
            />
        </div>

        <div className={styles.Bazaar2__placeCount}>
            <LoadingPlaceholder width={300} height={34} />
        </div>
    </div>
);

Bazaar2Placeholder.displayName = "Bazaar2Placeholder";
Bazaar2Placeholder = React.memo<PlaceholderOwnProps>(Bazaar2Placeholder);

export { Bazaar2Placeholder };
